import type { IntervalUnit } from '../../types';

const VALID_UNITS: readonly IntervalUnit[] = ['hours', 'flights', 'cycles'];

const MIN_INTERVAL_VALUE = 1;

const MAX_INTERVAL_VALUE = 100000;

export const isValidInterval = ({ unit, value }: { unit: string; value: number }): boolean => {
    if (!Number.isFinite(value)) {
        return false;
    }

    if (value < MIN_INTERVAL_VALUE || value > MAX_INTERVAL_VALUE) {
        return false;
    }

    return VALID_UNITS.includes(unit as IntervalUnit);
};
